import React from "react";
import { Table, Columns, Form} from "react-bulma-components";
import { readableDate } from "../../utils";

class PrintPickList extends React.Component {

  render() {

    const job = this.props.data;
    const {vehicle} = job;
    const parts = job.work_items.filter(item => item.complete === false).reduce((allParts, workItem) => {
      const parts = workItem.parts.map((part) => {
        return {
          ...part,
          workDescription: workItem.description
        }
      });
      return [...allParts, ...parts];
    }, []);

    let make = job.vehicle.make;
    let model = job.vehicle.model;
    let workshop = job.workshop;
    let customer = job.customer;
    let customer2 = job.customer2;
    // Shocking but print needs to handle getting model name and model objects
    if(job.vehicle.make && job.vehicle.make.constructor.name === 'Object'){
        make = job.vehicle.make.name
    }
    if(job.vehicle.model && job.vehicle.model.constructor.name === 'Object'){
        model = job.vehicle.model.name
    }
    if(job.workshop && job.workshop.constructor.name === 'Object'){
        workshop = job.workshop.display_name
    }
    if(job.customer && job.customer.constructor.name === 'Object'){
        customer = job.customer.display_name
    }
    if(job.customer2 && job.customer2.constructor.name === 'Object'){
        customer2 = job.customer2.display_name
    }

    let blankWriteUpRows = [];
    for (let i=0; i< 20; i++){
      blankWriteUpRows.push(
          <tr>
            <td className={"wider-column"}>&nbsp;</td>
            <td></td>
            <td></td>
          </tr>
      )
    }

    const totalPartRows = 15 - parts.length;
    let blankRows = [];
    for (let i = 0; i < totalPartRows; i++) {
      blankRows.push(
          <tr>
            <td>&nbsp;</td>
            <td></td>
            <td></td>
          </tr>
      );
    }
    return (
      <div>
        <br/>
        <Columns>
          <Columns.Column>
            {/*<img src={logo} style={{width: '110px', height: '35px'}} alt="Rentals Direct Ltd" />*/}
            <h2 className="job-card-print-title" data-testid={"title"}>
              {workshop} -{" "}
              {job.vehicle ? job.vehicle.registration : ""}{job.vehicle ? job.vehicle.vin_number ? '/' + job.vehicle.vin_number : "" : ""} - Workshop Date:{" "}
              {job.workshop_date && readableDate(job.workshop_date)}
            </h2>
          </Columns.Column>
        </Columns>
        <Columns>
          <Columns.Column>
            <Columns>
              <Columns.Column>
                <Table bordered>
                  <thead>
                    <tr>
                      <th>Customer</th>
                      <th>Customer2</th>
                      <th>Job ID</th>
                    </tr>
                  </thead>
                  <tr>
                    <td data-testid={"customer1"}>{customer}</td>
                    <td data-testid={"customer2"}>{customer2}</td>
                    <td data-testid={"job-id"}>{job.id}</td>
                  </tr>
                </Table>
              </Columns.Column>
            </Columns>
            <Columns>
              <Columns.Column>
                <Table bordered size={"fullwidth"}>
                    <thead>
                    <tr>
                      <td colSpan={1} className="cell-header"><b>MAKE / MODEL:</b></td>
                      <td colSpan={2} data-testid={"vehicle-make/model"}>{make} - {model}</td>
                    </tr>
                    <tr className="header-row">
                      <td>Part Description</td>
                      <td>Part Number</td>
                      <td>Part Used</td>

                    </tr>
                    </thead>
                    <tbody>
                    {
                      parts.map(({workDescription, ...part}, index) => <tr key={`${index}`}>
                        <td data-testid={"part-picklist-name"+index}>{part.name ?? ''}</td>
                        <td data-testid={"part-number"+index}>{part.part_number ?? ''}</td>
                        <td></td>
                      </tr>)
                    }
                    {
                      blankRows.map(row => row)
                    }
                    </tbody>
                </Table>
              </Columns.Column>
            </Columns>
          </Columns.Column>
          <Columns.Column>
              <Table size={"fullwidth"} bordered>
                <thead>
                  <tr>
                    <th>Write Up</th>
                    <th>Done</th>
                    <th>Not Done</th>
                  </tr>
                </thead>
                <tbody>
                  {blankWriteUpRows.map(row => row)}
                </tbody>
              </Table>
          </Columns.Column>
        </Columns>
      </div>
    );
  }
}

export default PrintPickList;
